// Library import

import {Modal} from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import TodoIcon from '~/images/icon/todo.png';

export const ShowNonUserModal = ({show, userId, handleClose}) => {
    return (
        <Modal show={show} onHide={handleClose} centered animation={true} className='modal-wrapper' backdrop='static'>
            <div className='p-5'>
                <div className='modal-common-content text-center'>
                    <img src={TodoIcon} alt='Trash icon'/>
                    <p className='text my-4'>
                        アカウント管理ページをご覧になられたい場合は、
                        <br/> マスターアカウントにてログインし直してください。
                    </p>

                    <div className='action-btn d-flex justify-content-center align-items-center'>
                        <button className='button primary' onClick={() => window.open('/admin/logout', '_self')}>
                            ログアウト
                        </button>
                        <button className='button outline'
                                onClick={() => window.open('/admin/posts?type=case_study', '_self')}>
                            キャンセル
                        </button>
                    </div>
                </div>

                <div className='close-modal' onClick={handleClose}>
                    <img src={CrossIcon} alt='Cross icon'/>
                </div>
            </div>
        </Modal>
    );
};

ShowNonUserModal.prototype = {
    show: Proptypes.bool,
    handleClose: Proptypes.func,
    userId: Proptypes.number
};
